module.exports = __webpack_public_path__ + "img/disabletaken.23494ea6.svg";